<template>
  <span>{{ compData.message }}</span>
</template>

<script setup>
const props = defineProps({
  compData: {
    type: Object,
    default: {},
  },
});
</script>
